import {map, Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel, YascEntityApiAdapterV3} from '@yasc/yasc-material-components';
import {ApiV0Company} from './api.v0.company';
import {
    BulkCompanyCreateReq,
    CompanyCreateReq,
    CompanyDetailsRes,
    CompanyUpdateReq,
} from '../../../../contracts/v0/cp';

/**
 * V3 entity api adapter for the company entity. It delegates to the existing {@link ApiV0Company} endpoints so the
 * proven request/response wiring (create via bulk onboard, patch via update, bulk delete) is reused unchanged.
 * The routes stay on /api/v0/company/* (see plan decision), no new backend route is introduced.
 */
export class ApiV0CompanyV3
    implements YascEntityApiAdapterV3<CompanyDetailsRes, CompanyDetailsRes, CompanyCreateReq, CompanyUpdateReq, number> {
    readonly modelTypes = {
        row: CompanyDetailsRes,
        detail: CompanyDetailsRes,
        create: CompanyCreateReq,
        patch: CompanyUpdateReq,
    };

    readonly idKey = 'id' as const;

    constructor(private readonly company: ApiV0Company) {}

    search(searchModel: SearchModel = new SearchModel({})): Observable<BaseCollectionModel<CompanyDetailsRes>> {
        return this.company.search(searchModel);
    }

    detail(id: number): Observable<CompanyDetailsRes> {
        return this.company.details(`${id}`);
    }

    create(createReq: CompanyCreateReq): Observable<CompanyDetailsRes> {
        return this.company.bulkPost(new BulkCompanyCreateReq([createReq])).pipe(map(result => result.data[0]));
    }

    patch(id: number, updateReq: CompanyUpdateReq): Observable<CompanyDetailsRes> {
        updateReq.id = id;
        return this.company.update(updateReq);
    }

    delete(ids: number[]): Observable<void> {
        const distinctIds = [...new Set((ids ?? []).filter(id => id > 0))];
        return this.company.bulkDelete(distinctIds).pipe(map(() => undefined));
    }
}
